module.exports = __webpack_public_path__ + "img/album03_07.810fc9f9.jpg";